export const GET_BANNERS_ACTIVE = 'account_setting/GET_BANNERS_ACTIVE';
export const SET_BANNERS_ACTIVE = 'account_setting/SET_BANNERS_ACTIVE';
